import { firestoreAction } from 'vuexfire';
import { db } from '@/plugins/firebaseDB';


const initialState = {
  stories: [],
};

const getters = {
  getStories: state => state.stories,
  getStory: state => index => state.stories.find(story => story.id === index),
  getStoriesBySprint(state) {
    return sprintId => state.stories.filter((story) => {
      if (story.sprint !== null) {
        return story.sprint.id === sprintId;
      }
      return null;
    });
  },
  getBacklogStories(state) {
    return state.stories.filter(story => story.sprint === null);
  },
};

const mutations = {
  createStory: (state, story) => {
    if (story.sprint === undefined || story.sprint === null) {
      story.sprint = null;
    } else if (typeof story.sprint === 'string') {
      story.sprint = db.collection('sprints').doc(story.sprint);
    } else if (typeof story.sprint.id === 'string') {
      story.sprint = db.collection('sprints').doc(story.sprint.id);
    }
    if (story.owner === undefined || story.owner === null) {
      story.owner = null;
    } else if (typeof story.owner === 'string') {
      story.owner = db.collection('users').doc(story.owner);
    } else if (typeof story.owner.id === 'string') {
      story.owner = db.collection('users').doc(story.owner.id);
    }
    db.collection('stories').add(story);
  },
  updateStory: (state, story) => {
    if (story.sprint === undefined || story.sprint === null) {
      story.sprint = null;
    } else if (typeof story.sprint === 'string') {
      story.sprint = db.collection('sprints').doc(story.sprint);
    } else if (typeof story.sprint.id === 'string') {
      story.sprint = db.collection('sprints').doc(story.sprint.id);
    }
    if (story.owner === undefined || story.owner === null) {
      story.owner = null;
    } else if (typeof story.owner === 'string') {
      story.owner = db.collection('users').doc(story.owner);
    } else if (typeof story.owner.id === 'string') {
      story.owner = db.collection('users').doc(story.owner.id);
    }
    db.collection('stories').doc(story.id).update(story);
  },
  deleteStory: (state, story) => {
    db.collection('stories').doc(story.id).delete();
  },
};

const actions = {
  bindStories: firestoreAction(({ bindFirestoreRef }) => bindFirestoreRef('stories', db.collection('stories').orderBy('title'))),
  createStory: (context, story) => {
    context.commit('createStory', story);
  },
  updateStory: (context, story) => {
    context.commit('updateStory', story);
  },
  deleteStory: (context, story) => {
    context.commit('deleteStory', story);
  },
};

export default {
  state: initialState,
  mutations,
  actions,
  getters,
};
